export type PaddingInput = {
  top: string
  _uid: string
  left: string
  unit: 'px' | 'rem' | 'em'
  right: string
  bottom: string
  mob_top: string
  mob_left: string
  component: string
  mob_right: string
  mob_bottom: string
  tablet_top: string
  tablet_left: string
  tablet_right: string
  tablet_bottom: string
  _editable: string
}

export interface StylePanelProps {
  padding?: {
    unit?: 'px' | 'rem' | 'em'
    default?: boolean
    desktop?: {
      top: number
      right: number
      bottom: number
      left: number
    }
    tablet?: {
      top: number
      right: number
      bottom: number
      left: number
    }
    mobile?: {
      top: number
      right: number
      bottom: number
      left: number
    }
  }
  alignment?: 'center' | 'left' | 'right'
  backgroundColor?: string
  textColor?: string
}
const generatePaddingString = (
  padding: { top: number; right: number; bottom: number; left: number },
  unit: string
) => {
  return `${padding.top}${unit} ${padding.right}${unit} ${padding.bottom}${unit} ${padding.left}${unit}`
}

export const setPadding = (padding: StylePanelProps['padding']) => {
  const {
    unit = 'rem',
    desktop = { top: 0, right: 0, bottom: 0, left: 0 },
    tablet = { top: 0, right: 0, bottom: 0, left: 0 },
    mobile = { top: 0, right: 0, bottom: 0, left: 0 },
  } = padding || {}

  let desktopPadding = generatePaddingString(desktop, unit)
  let tabletPadding = generatePaddingString(tablet, unit)
  let mobilePadding = generatePaddingString(mobile, unit)

  const styles = `
    padding: ${desktopPadding};

    @media (max-width: 768px) {
      padding: ${tabletPadding};
    }

    @media (max-width: 480px) {
      padding: ${mobilePadding};
    }
  `

  return styles
}

export const convertPadding = (paddingArray: any[]) => {
  if (paddingArray === undefined || paddingArray.length === 0) {
    return {
      unit: 'px',
      default: false,
      desktop: { top: 0, right: 0, bottom: 0, left: 0 },
      tablet: { top: 0, right: 0, bottom: 0, left: 0 },
      mobile: { top: 0, right: 0, bottom: 0, left: 0 },
    }
  }

  const padding = paddingArray[0]

  // if paadding default is true, return the default padding
  if (padding.enableDefaultPadding) {
    return {
      unit: 'rem',
      default: true,
      desktop: { top: 2, right: 0, bottom: 2, left: 0 },
      tablet: { top: 1.5, right: 0, bottom: 1.5, left: 0 },
      mobile: { top: 1, right: 0, bottom: 1, left: 0 },
    }
  }

  return {
    unit: padding.unit || 'px',
    default: padding.enableDefaultPadding || false,
    desktop: {
      top: parseInt(padding.top) || 0,
      right: parseInt(padding.right) || 0,
      bottom: parseInt(padding.bottom) || 0,
      left: parseInt(padding.left) || 0,
    },
    tablet: {
      top: parseInt(padding.tablet_top) || 0,
      right: parseInt(padding.tablet_right) || 0,
      bottom: parseInt(padding.tablet_bottom) || 0,
      left: parseInt(padding.tablet_left) || 0,
    },
    mobile: {
      top: parseInt(padding.mob_top) || 0,
      right: parseInt(padding.mob_right) || 0,
      bottom: parseInt(padding.mob_bottom) || 0,
      left: parseInt(padding.mob_left) || 0,
    },
  }
}

export const stylePanelSBData = (
  colour: any,
  background: any,
  alignment: any,
  padding: any
): StylePanelProps => {
  const backgroundColor = background && background[0] && (background[0].colour as string)
  const textColor = colour && colour[0] && (colour[0].colour as string)
  const alignmentSet = alignment && alignment[0] && (alignment[0].alignment as string)

  return {
    padding: padding ? convertPadding(padding) : undefined,
    alignment: alignmentSet ? alignmentSet : 'left',
    backgroundColor: backgroundColor ? backgroundColor : '',
    textColor: textColor ? textColor : '',
  }
}
